import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Services
import { SiteService } from '../../services';

@Component({
  selector: 'job-detail-seo',
  templateUrl: 'job-detail-seo.component.html',
})

export class JobDetailSeoComponent implements OnInit {

  @Input() public jobDetails: object;

  private jsonSchema: object = {
    '@context': 'http://schema.org',
    '@type': 'JobPosting',
  };

  constructor(
    private siteService: SiteService
  ) { }

  ngOnInit() {

    this.jsonSchema['url'] = this.siteService.getCurrentUrl();
    this.jsonSchema['title'] = this.jobDetails['jobTitle'];
    this.jsonSchema['description'] = this.jobDetails['jobDescription'];
    if (this.jobDetails['qualifications']['jobRequirement']) {
      this.jsonSchema['description'] += this.jobDetails['qualifications']['jobRequirement'];
    }
    this.jsonSchema['datePosted'] = this.jobDetails['postedDate'];
    this.jsonSchema['employmentType'] = this.jobDetails['categories'].map(x => x.toUpperCase().replace(/-/g, '_')).join(', ');
    this.jsonSchema['industry'] = this.jobDetails['industries'].map(x => x).join(', ');
    this.jsonSchema['hiringOrganization'] = {
      '@type': 'Organization',
      name: this.jobDetails['company'],
    };
    this.jsonSchema['jobLocation'] = {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: this.jobDetails['city'],
        addressRegion: this.jobDetails['stateProvCode'],
        streetAddress: this.jobDetails['addressLine1'],
        postalCode: this.jobDetails['postalCode'],
      }
    };
  }

  getJson() {
    return '<script type="application/ld+json">' + JSON.stringify(this.jsonSchema) + '</script>';
  }
}